import Svg, { Circle, Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgIconCheckFlat = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={110} height={115} fill="none" viewBox="0 0 110 115" {...props}><Circle cx={55} cy={60} r={55} fill="currentColor" /><Path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth={5} d="M32 59.67 47.86 76 77 46" /></Svg>;
const Memo = memo(SvgIconCheckFlat);
export default Memo;